import { render } from "./MultiView.vue?vue&type=template&id=0ed17d4c"
import script from "./MultiView.vue?vue&type=script&lang=js"
export * from "./MultiView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__